/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import { RangeControl } from '@wordpress/components';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import BlockLayouts from '../../../components/block-layouts';

import blockInfo from '../constants';
import childBlockInfo from '../team-member/constants';
const { hookPrefix } = blockInfo;
const { layouts, hookPrefix: childBlockHookPrefix } = childBlockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const { attributes, setAttributes, updateInnerBlocks } = props;
		const { layout, columnSize } = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'team',
						initialOpen: true,
						label: () => {
							return __( 'Team' );
						},
						cb: () => {
							return <>
								<BlockLayouts layouts={ layouts } value={ layout } blockName={ childBlockHookPrefix } onChange={ ( val ) => {
									const data = {
										layout: val.name,
										socialIconAlign: val.socialIconAlign,
										imageAlign: val.imageAlign,
										titleAlign: val.titleAlign,
									};
									setAttributes( data );
									updateInnerBlocks( val );
								} } />
								<RangeControl value={ columnSize } label={ __( 'Columns' ) } min={ 1 } max={ 4 } step={ 1 } onChange={ ( value ) => {
									setAttributes( { columnSize: value } );
								} } />
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);
